import { DynamicModule } from '1-project/DynamicModule/DynamicModule';
import { GoToTopNavigation } from '2-feature/Navgation/GoToTopNavigation';
import { MainRegion } from '1-project/MainRegion/MainRegion';
import { NewsSearchResults } from '2-feature/Search/NewsSearchResults';
import { CludoComment } from 'ui/components/10-vendors/cludo/CludoComment';

interface Props extends Content.Page {
	properties: Content.NewsCatalogPageProperties;
}

export const NewsCatalogPage = ({ properties }: Props) => {
	const { pageHeader, newsItems, filterTags, totalNewsItems } = properties ?? {};

	return (
		<MainRegion
			header={pageHeader.map((headerModule, index) => (
				<DynamicModule key={index} module={headerModule} />
			))}
		>
			<CludoComment>
				<NewsSearchResults serverSideNewsItems={newsItems} tags={filterTags} totalNewsItems={totalNewsItems} />
			</CludoComment>
			<GoToTopNavigation />
		</MainRegion>
	);
};
